
<script>import Loader from '/app/components/Loader.html'
import { tween } from 'svelte-extras'
import * as eases from 'eases-jsnext'
import { setFocus } from '/helpers/misc'
import { getElementOffset } from '/helpers/window'
import { navItems, checkState } from '/helpers/list-helpers'

export default {

	data() {
		return {
			preQuery: '',
		}
	},

	computed: {
		loaded: items => !!items,
		pagesize: windowWidth => {
			if (windowWidth < _MEDIA_SMALL) {
				return 8
			} else if (windowWidth < _MEDIA_MEDIUM) {
				return 6
			}
			return 8
		},
		filteredItems: (items, query, departmentFilter) => {
			// filter and sort
			if (query && query.trim()) {
				const fuse = new Fuse(items.slice(), {
					// shouldSort: true,
					keys: ['name'],
					threshold: 0.5,
				})
				items = fuse.search(query)
			}
			if (departmentFilter !== 'all') {
				items = _.filter(items, { departmentKey: departmentFilter })
			}
			return _.sortBy(items, ['last', 'first'])
		},
		paginatedItems: (filteredItems, page, pagesize) => {
			const start = (page - 1) * pagesize
			filteredItems = filteredItems.slice(start, start + pagesize)
			return filteredItems
		},
		navRange: (filteredItems, pagesize) => _.range(1, (filteredItems.length / pagesize) + 1),
		navItems: (filteredItems, page, navRange) => navItems(filteredItems, page, navRange),
	},

	oncreate() {

		this.getOptionSize()

		// just some simple state management
		this.observe('departmentFilter', departmentFilter => this.checkState('departmentFilter', departmentFilter, 'all'))
		this.observe('query', query => this.checkState('query', query, ''))
		this.observe('page', page => this.checkState('page', page, 1))

		// one time fetch
		fetch(this.get('url'))
			.then(response => response.json())
			.then(json => {
				this.set({
					items: json.directory,
					departments: json.departments,
				})
			})
			// TODO: handle errors gracefully?
			// .catch(ex => console.log('parsing failed', ex))

		// I hate this indirection, but it works...
		this.observe('yPosMirror', yPos => {
			this.set({ yPos })
		}, { init: false })
	},

	components: {
		Loader,
	},

	methods: {
		tween,
		submitFilters(event, preQuery) {
			event.preventDefault()
			this.set({ query: preQuery })
			this.getOptionSize()
		},
		navigate(event, direction) {
			event.preventDefault()
			let page = this.get('page')
			if (direction === 'previous') {
				--page
			} else if (direction === 'next') {
				++page
			} else {
				page = direction
			}
			this.set({ page })

			// scroll up
			if (this.get('windowWidth') < _MEDIA_SMALL) {
				this.set({ yPosMirror: this.get('yPos') })
				this.tween('yPosMirror', getElementOffset(this.refs.list) - 100, {
					duration: 1000,
					easing: eases.cubicOut,
				})
			}
			// focus first item
			setFocus(this.refs.list)
		},

		checkPagination(navRange, page) {
			if (navRange.length < parseInt(page)) {
				this.set({ page: navRange.length })
			}
		},

		checkState,

		getOptionSize() {
			this.set({ optionText: this.refs.select.querySelector('option:checked').textContent })
			// wait for DOM
			setTimeout(() => {
				this.set({ optionTextSize: this.refs.optionText.getBoundingClientRect().width })
			}, 0)
		},
	},

}

</script><:Window bind:scrollY="yPos" bind:innerWidth="windowWidth" on:resize="checkPagination(navRange, page)"/>
<div class="listing-toolbar fullwidth">
  <form class="directory-filters" on:submit="submitFilters(event, preQuery)">
    <div class="group filter-group">
      <div class="option-text-wrap">
        <div class="option-text" ref:optionText>{{optionText}}</div>
      </div>
      <label>Department<span class="select-box" style="width:{{optionTextSize + 25}}px;">
          <select bind:value="departmentFilter" on:change="getOptionSize()" ref:select>
            <option value="all">All</option>{{#if loaded}}{{#each departments as dept}}
            <option value="{{dept.key}}">{{dept.value}}</option>{{/each}}{{/if}}
          </select></span></label>
    </div>
    <div class="group query-group">
      <label class="input-box">
        <div class="ghost">Search Directory:</div>
        <input type="text" bind:value="preQuery">
        <button type="submit"><span class="ghost">Search</span></button>
      </label>
    </div>
  </form>
</div>
<div class="directory block" ref:list>
  <div class="items grid-x grid-margin-x">{{#if paginatedItems.length}}{{#each paginatedItems as item}}
    <div class="item cell small-12 medium-4 large-3">
      <div class="card">
        <div class="card-divider">
          <div class="bg" style="background-image:url({{item.image}});"><img src="{{item.image}}" alt="{{item.imageAlt}}"></div>
        </div>
        <div class="card-section">
          <h2 class="title"><a href="{{item.url}}">{{item.name}}</a></h2>
          <div class="job-title">{{item.jobTitle}}</div>
          <div class="department">{{item.department}}</div>
        </div>
      </div>
    </div>{{/each}}{{else}}
    <Loader></Loader>{{/if}}
  </div>{{#if navItems.length > 1 && paginatedItems.length}}
  <nav class="list-navigation" role="navigation" aria-label="Directory list pagination">
    <ul class="pagination">{{#if page <= 1}}
      <li class="pagination-previous disabled"><span class="show-for-sr">Previous page</span></li>{{else}}
      <li class="pagination-previous"><a on:click="navigate(event, 'previous')" href="/" aria-label="Previous page"><span class="show-for-sr">Previous page</span></a></li>{{/if}}{{#each navItems as item}}{{#if item.on}}
      <li class="current"><span class="show-for-sr">You're on page </span>{{item.value}}</li>{{elseif item.etc}}
      <li class="ellipsis" aria-hidden="true"></li>{{else}}
      <li><a on:click="navigate(event, item.value)" href="/" aria-label="Page {{item.value}}">{{item.value}}</a></li>{{/if}}{{/each}}{{#if page >= navRange.length}}
      <li class="pagination-next disabled"><span class="show-for-sr">Next page</span></li>{{else}}
      <li class="pagination-next"><a on:click="navigate(event, 'next')" href="/" aria-label="Next page"><span class="show-for-sr">Next page</span></a></li>{{/if}}
    </ul>
  </nav>{{/if}}
</div>